import { Bot, LogOut } from "lucide-react";

export default function SidebarNavigation({ menu, tab, onSelect, onLogout, mobile = false }) {
  return <>
    <div className="h-16 shrink-0 flex items-center gap-2 px-5 pr-12 border-b border-[#E2E8F0]">
      <div className="w-8 h-8 shrink-0 rounded-lg bg-[#2563EB] flex items-center justify-center"><Bot size={18} className="text-white" /></div>
      <span className="font-heading font-extrabold tracking-tight">ContentChat<span className="text-[#2563EB]">AI</span></span>
    </div>
    <nav aria-label="Menu utama" className="min-h-0 flex-1 overflow-y-auto p-3 space-y-1">
      {menu.map((item) => <button
        key={item.key}
        onClick={() => onSelect(item.key)}
        aria-current={tab === item.key ? "page" : undefined}
        data-testid={`${mobile ? "mobile-" : ""}menu-${item.key}`}
        className={`w-full min-h-11 flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${tab === item.key ? "bg-[#2563EB] text-white" : "text-slate-600 hover:bg-[#F1F5F9] hover:text-slate-900"}`}
      ><item.icon size={18} className="shrink-0" />{item.label}</button>)}
    </nav>
    <div className="shrink-0 p-3 border-t border-[#E2E8F0] pb-[max(0.75rem,env(safe-area-inset-bottom))]">
      <button onClick={onLogout} data-testid={mobile ? "mobile-logout-button" : "logout-button"} className="w-full min-h-11 flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-slate-600 hover:bg-[#F1F5F9] hover:text-[#E11D48] transition-colors"><LogOut size={18} /> Keluar</button>
    </div>
  </>;
}
